__webpack_require__.p = "/infobox-refresh/referrals/";